import React, { Component } from 'react';  
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';
import {getCondition} from '../../action/investmentAction.js';
import { connect } from 'react-redux';
import { Toast } from 'antd-mobile/lib';
import { GuidePageType } from "../guidePage/index.js";
import { onMiniProgramDialog } from "../../common.js"
import Guide from '../guidePage';

class RceoQuestionFinish extends Component { 
  state = {
    flag: false
  } 

  componentWillMount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评结果页", "进入"]);
    document.getElementsByTagName('title')[0].innerHTML = "风险偏好测评";
  }

  componentWillUnmount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评结果页", "退出"]);
    Guide.leave();
  }

  componentDidMount() {
    
  }

  goDetail = (result) => {
    window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评结果页", "组合详情"]);
    const isMiniProgram = onMiniProgramDialog(GuidePageType.Trade)
    if (isMiniProgram) return
    let { dispatch, isLogin } = this.props;
    let superFundCode = result.superFundCode;
    
    hashHistory.push({
      pathname: "/SuperFundDetail",
      state:{
        superFundCode: superFundCode,
        isTop: true
      },
      query:{
        superFundCode: superFundCode,
        isTop: true
      }
    })
  }

  render() { 
    let { riskEvaluationPieData } = this.props.location.state;
    let imgIcon = [];
    let imgIcon2 = [];
    if(riskEvaluationPieData.content.superFundCode == "SF1012") {
      imgIcon2.push(
          <img
          key={0}
          src={require("../../img/junhengx.png")}
          style={{width: 25, height: 25, marginTop: 40}}
          />
      );
      imgIcon.push(
          <img
          key={0}
          src={require("../../img/zhizhen.png")}
          style={{width: window.winWidth === 320 ? 140 : 169, height: window.winWidth === 320 ? 140 : 169, position: "absolute", left: 0, top: 0, WebkitTransform: "rotate(-120deg)"}}
          />
      );
    }else if(riskEvaluationPieData.content.superFundCode == "SF1015") {
      imgIcon2.push(
          <img
          key={0}
          src={require("../../img/junhengx.png")}
          style={{width: 25, height: 25, marginTop: 40}}
          />
      );
      imgIcon.push(
          <img
          key={0}
          src={require("../../img/zhizhen.png")}
          style={{width: window.winWidth === 320 ? 140 : 169, height: window.winWidth === 320 ? 140 : 169, position: "absolute", left: 0, top: 0, WebkitTransform: "rotate(0deg)"}}
          />
      );
    }else if(riskEvaluationPieData.content.superFundCode == "SF1016") {
      imgIcon2.push(
          <img
          key={0}
          src={require("../../img/junhengx.png")}
          style={{width: 25, height: 25, marginTop: 40}}
          />
      );
      imgIcon.push(
          <img
          key={0}
          src={require("../../img/zhizhen.png")}
          style={{width: window.winWidth === 320 ? 140 : 169, height: window.winWidth === 320 ? 140 : 169, position: "absolute", left: 0, top: 0, WebkitTransform: "rotate(60deg)"}}
          />
      );
    }else if(riskEvaluationPieData.content.superFundCode == "SF1014") {
      imgIcon2.push(
          <img
          key={0}
          src={require("../../img/junhengx.png")}
          style={{width: 25, height: 25, marginTop: 40}}
          />
      );
      imgIcon.push(
          <img
          key={0}
          src={require("../../img/zhizhen.png")}
          style={{width: window.winWidth === 320 ? 140 : 169, height: window.winWidth === 320 ? 140 : 169, position: "absolute", left: 0, top: 0, WebkitTransform: "rotate(120deg)"}}
          />
      );
    }
    return (  
      <div className="mainBox"> 
        <div
        style={{position: "relative", width: window.winWidth, backgroundSize: "cover", backgroundImage: `url(${require("../../img/clbsBg.jpg")})`, display: "-webkit-flex", WebkitFlexDirection: "column", minHeight: window.winHeight}}
        >
          <NavigatorMain>
            <div className="boxHeader" style={{backgroundColor: "transparent"}}>
              <div>
                
              </div>
              <div>
                <span>风险偏好测评</span>
              </div>
              <div>
                
              </div>
            </div>
          </NavigatorMain> 
          <div className="boxContent">
            <div style={{
              width: window.winWidth,
              paddingLeft: 13,
              paddingRight: 13,
              WebkitFlexDirection: "row",
              WebkitJustifyContent: "space-between",
              WebkitAlignItems: "center",
              display: "-webkit-flex",
              paddingTop: 20
            }}>
              <img alt="" style={{width: 63, height: 63}} src={require("../../img/jqrIcon.png")} />
              <div style={{paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth-96, borderRadius: 10}}>
                <span style={{
                  color: "#fff",
                  lineHeight: "16px",
                  fontSize: 13
                }}>经测评，您的风险偏好为{riskEvaluationPieData.content.superFundCode == "SF1012" ? "低" : riskEvaluationPieData.content.superFundCode == "SF1015" ? "中" : riskEvaluationPieData.content.superFundCode == "SF1016" ? "中高" : riskEvaluationPieData.content.superFundCode == "SF1014" ? "高" : ""}风险偏好，为您推荐“{riskEvaluationPieData.content.superFundCode == "SF1012" ? "货币优享组合" : riskEvaluationPieData.content.superFundCode == "SF1015" ? "固收增强组合" : riskEvaluationPieData.content.superFundCode == "SF1016" ? "权益优选组合" : riskEvaluationPieData.content.superFundCode == "SF1014" ? "指数轮动组合" : ""}”</span>
              </div> 
            </div>
            <div style={{position: "relative", height: 200, width: window.winWidth, paddingLeft: 13, paddingRight: 13, marginTop: 25}}>
              <div style={{backgroundColor: "rgba(0, 0, 0, 0.2)", borderRadius:10, paddingLeft: 13,paddingRight: 13,WebkitJustifyContent: "center",WebkitFlexDirection: "row", display: "-webkit-flex", height: 200}}>
                <div style={{position: "relative", WebkitAlignItems: "flex-start", display: "-webkit-flex", WebkitFlexDirection: "column", WebkitFlex: 0.4}}>
                  {
                    imgIcon2
                  }
                  <div style={{marginTop: 9, fontSize: 15, color: "#fff"}}>{riskEvaluationPieData.content.superFundCode == "SF1012" ? "货币优享组合" : riskEvaluationPieData.content.superFundCode == "SF1015" ? "固收增强组合" : riskEvaluationPieData.content.superFundCode == "SF1016" ? "权益优选组合" : riskEvaluationPieData.content.superFundCode == "SF1014" ? "指数轮动组合" : ""}</div>
                  <div style={{marginTop: 10, fontSize: "13px", color: "#fff"}}>{riskEvaluationPieData.content.superFundCode == "SF1012" ? "流动性强" : riskEvaluationPieData.content.superFundCode == "SF1015" ? "稳健理财" : riskEvaluationPieData.content.superFundCode == "SF1016" ? "灵活配置" : riskEvaluationPieData.content.superFundCode == "SF1014" ? "紧跟市场" : ""}</div>
                  <div style={{marginTop: 5, fontSize: "13px", color: "#fff"}}>{riskEvaluationPieData.content.superFundCode == "SF1012" ? "国民理财升级" : riskEvaluationPieData.content.superFundCode == "SF1015" ? "追求资产增值" : riskEvaluationPieData.content.superFundCode == "SF1016" ? "掘金超额收益" : riskEvaluationPieData.content.superFundCode == "SF1014" ? "做聪明投资者" : ""}</div>
                </div>
                <div  style={{display: "-webkit-flex", position: "relative", WebkitFlex: 0.6, WebkitJustifyContent: "flex-end"}}>
                  <div
                  style={{position: "relative",backgroundImage: `url(${require("../../img/zhuanpan.png")})`, backgroundSize: "cover", width: window.winWidth == 320 ? 140 : 169, height: window.winWidth == 320 ? 140 : 169, marginTop: 30}}
                  >
                  {
                    imgIcon
                  }
                  </div>
                </div>
              </div>
            </div>
            <div style={{ position: "absolute", bottom: 60, width: "100%"}}>
              <div style={{ margin: "0 auto", display: "-webkit-flex", width: 209,height: 40,backgroundColor: "transparent",border: "1px solid #fff",borderRadius: 25,WebkitJustifyContent: "center",WebkitAlignItems: "center"}} onClick={() => this.goDetail(riskEvaluationPieData.content)}>
                <span style={{fontSize: 15, color: "#fff"}}>查看详情</span>
              </div>
            </div>
          </div>
        </div>
      </div>  
    );  
  }  
}  

function mapStateToProps(state, ownProps) {
  return {
    isLogin: state.isLogin
  }
}
  
export default  connect(mapStateToProps)(RceoQuestionFinish);


// WEBPACK FOOTER //
// ./src/components/recommend/RecoQuestionFinish.js